import React from 'react';

import logoSxc from '../img/logosxc.png';
import MapView from './MapView';

export default function Footer(){
  return (
    <footer className="container-fluid bg-secondary text-white mt-5 py-5">
      <div className="container">
        <div className="row pt-5">
          {/* Logo and About */}
          <div className="col-lg-4 col-md-6 mb-5 d-flex flex-column align-items-center text-center">
            <a href="#home" className="navbar-brand font-weight-bold text-primary m-0 mb-4 p-0 d-flex flex-column align-items-center" style={{fontSize:40,lineHeight:'40px'}}>
              <img src={logoSxc} alt="logo" style={{height:72, width:'auto', marginBottom:12, borderRadius:'6px', objectFit:'contain'}} />
              <span className="text-white">St. Francis Xavier</span>
            </a>
            <p>Excellence in Education. Nurturing minds for a brighter future. Since 1884.</p>
          </div>
          
          {/* Get In Touch - Contact Info */}
          <div className="col-lg-4 col-md-6 mb-5 d-flex flex-column align-items-center justify-content-center">
            <h5 className="text-primary mb-5 text-center">Get In Touch</h5>
            <div className="w-100 d-flex flex-column align-items-center" style={{ maxWidth: '300px' }}>
              <div className="mb-4 w-100">
                <div className="d-flex align-items-start">
                  <i className="fa fa-map-marker-alt text-primary mr-3 mt-1" style={{ fontSize: '1.2rem', flexShrink: 0 }}></i>
                  <div style={{ flex: 1 }}>
                    <h6 className="text-white mb-1" style={{ fontSize: '0.95rem' }}>Address</h6>
                    <p className="mb-0" style={{ fontSize: '0.9rem' }}>Thoothukudi, Tamil Nadu</p>
                  </div>
                </div>
              </div>
              <div className="w-100">
                <div className="d-flex align-items-start">
                  <i className="fa fa-phone text-primary mr-3 mt-1" style={{ fontSize: '1.2rem', flexShrink: 0 }}></i>
                  <div style={{ flex: 1 }}>
                    <h6 className="text-white mb-1" style={{ fontSize: '0.95rem' }}>Phone</h6>
                    <p className="mb-0" style={{ fontSize: '0.9rem' }}>+91-XXXX-XXXXXX</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Location Map */}
          <div className="col-lg-4 col-md-6 mb-5 d-flex flex-column align-items-center">
            <h5 className="text-primary mb-4 text-center">Our Location</h5>
            <MapView />
          </div>
       {/*}   <div className="col-lg-4 col-md-6 mb-5 d-flex flex-column align-items-center text-center">
            <h5 className="text-primary mb-4">Quick Links</h5>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <a className="text-white mb-3" href="#home"><i className="fa fa-angle-right mr-2"></i>Home</a>
              <a className="text-white mb-3" href="#about"><i className="fa fa-angle-right mr-2"></i>About Us</a>
              <a className="text-white mb-3" href="#classes"><i className="fa fa-angle-right mr-2"></i>Our Classes</a>
              <a className="text-white mb-3" href="#team"><i className="fa fa-angle-right mr-2"></i>Our Teachers</a>
              <a className="text-white" href="#contact"><i className="fa fa-angle-right mr-2"></i>Contact Us</a>
            </div>
          </div>*/}
        </div>

        {/* Copyright */}
        <div className="pt-5 text-center" style={{borderTop: '1px solid rgba(23, 162, 184, 0.2)'}}>
          <p className="m-0 text-white">&copy; 2025 <span className="text-primary font-weight-bold">idntica</span>. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  )
}
